import './App.css';
import Dat_PFP from './assets/Dat_PFP.webp';
import React, { useEffect, useState } from 'react';

function App() {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    fetch('https://content.bluenardo.app/items/dat_links')
      .then(res => res.json())
      .then(data => setLinks(data.data || []));
  }, []);

  return (
    <div className="root">
      <main>
        <div className="profile-section">
          <a href="http://web.bluenardo.blue">
            <img src={Dat_PFP} alt="" className="profile-icon" />
          </a>
        </div>
        <div className="link-tree">
          <h1>@DatGamerboi101</h1>
          <ul>
            {links.map((link) => (
              <li key={link.id}>
                <a href={link.links}>
                  <div className="link-container">
                    <img
                      src={`https://content.bluenardo.app/assets/${link.icon}.webp`}
                      alt=""
                      style={link.Rounded === true ? { borderRadius: '50%' } : undefined}
                    />
                    {link.text}
                  </div>
                </a>
              </li>
            ))}
          </ul>
          <div className="footer">
            <p><a href="https://kuma.bluenardo.app/status/dat-services">Dat Services Status</a></p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
